<template>
  <h1 class="text-2xl text-indigo-300">Управляющая компания</h1>
</template>
